// extracted by mini-css-extract-plugin
export var table = "_xz-0";